<template>
    <form @submit="submit" class="item-editor-form">
        <fg-input v-model="item.organisation.id" :label="$t('organisation.id')" :disabled="action == 'edit'"></fg-input>
        <fg-input v-model="item.organisation.name" :label="$t('organisation.name')"></fg-input>
        <fg-input v-model="item.organisation.address" :label="$t('organisation.address')"></fg-input>
        <fg-input v-model="item.organisation.postalcode" :label="$t('organisation.postalcode')"></fg-input>
        <fg-input v-model="item.organisation.city" :label="$t('organisation.city')"></fg-input>
        <fg-input v-model="item.organisation.phone" :label="$t('organisation.phone')"></fg-input>
        <fg-input v-model="item.organisation.agency_id" :label="$t('organisation.agency_id')"></fg-input>
        <fg-input v-model="item.organisation.agency_url" :label="$t('organisation.agency_url')"></fg-input>

        <b-form-group v-if="item && availableOrganisations">
            <label for="organisaatio">{{ $t('organisation.addable') }}:</label>
         <b-table
            striped 
            hover 
            :items="availableOrganisations" 
            :fields="fields">
                <template v-slot:cell(id)="data">
                    <b-icon icon="dash-square-fill" variant="danger" @click="onDeselectOrganisation(data.value)"
                font-scale="1.2" v-b-tooltip.hover :title="$t('button.delete')" 
                class="clickable"></b-icon>
                </template>

            </b-table>

          <SelectList :label="$t('organisation.add')" :options="selectedOrganisations" :value="organisationValue" @select="onSelectOrganisation" :disabled="loading"/>

        </b-form-group>

        <FormButtons
            @submit="submit" 
            :reset="false" 
            :remove="action == 'edit'" 
            @remove="remove"
            :itemid="this.item.organisation.id"
            :modalid="'organisationEditModal'"
            :disableSubmit="disabled || loading"
            :disableRemove="disabled || loading "/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

    </form>

</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import timetable from '@/store/timetable/timetable'
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        FormButtons
    },
    props: {
        item: {
            default: function () {
                return {
                    "organisation": {
                        "id": null,
                        "name": null
                    }
                }
            }
        },
        action: { default: "new" }
    },
    data: function() {
        return  {
            availableOrganisations: [],
            selectedOrganisations: [],
            ok: false,
            error: false,
            loading: false,
            disabled: false,
            infoType: "save",
            fields: [
                { key: "name", label: "" },
                { key: "id" , label: "" }
            ]
        }
    },
    computed: {
        organisationValue() {
            return (this.selectedOrganisations && this.selectedOrganisations.length > 0) ? this.selectedOrganisations[0].id : "";
        }
    },
    watch: {
        item(){
            this.selectedOrganisations = [];
            this.availableOrganisations = this.item.availableOrganisations;
            for (var o of this.item.addedOrganisations) {
                if (!this.listContains(o, this.selectedOrganisations))
                    this.selectedOrganisations.push({ id: o.id, label: o.id + " - " + o.name })
            }
            this.ok = this.error = this.loading = this.disabled = false;
        }
    },
    methods: {
        listContains(item, list) {
            for(var i = 0; i < list.length; i++) {
                if(list[i].id === item.id) {
                    return true;
                }
            }
            return false;
        },
        onDeselectOrganisation(id){
            var newList = [];
            for (var o of this.availableOrganisations) {
                if (o.id === id) {
                    this.selectedOrganisations.push({ id: o.id, label: o.id + " - " + o.name });
                } else {
                    newList.push(o);
                }
            }
            this.availableOrganisations = newList;
        },
        onSelectOrganisation(id) {
            var newList = [];
            for (var o of this.selectedOrganisations) {
                if (o.id !== id) {
                    newList.push(o);
                } else {
                    this.availableOrganisations.push({ id: o.id, name: o.label});
                }
            }
            this.selectedOrganisations = newList;
        },
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;

            this.item.addedOrganisations = this.availableOrganisations;
            this.item.availableOrganisations = [];

            for (var a of this.selectedOrganisations) {
                if (a.id)
                    this.item.availableOrganisations.push({ id: a.id });

            }

            this.$store.dispatch('timetable/updateOrganisation', this.item).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                        this.error = true;
                    })
                    .finally(() => {
                        this.loading = false;
                        this.$store.dispatch('timetable/getOrganisations');
                    })
        },
        reset(event){
            event.preventDefault();
            this.item = {};
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;

            this.$store.dispatch('timetable/deleteOrganisation', this.item.organisation.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                        this.error = true;
                    })
                    .finally(() => {
                        this.loading = false;
                        this.disabled = true;
                        this.$store.dispatch('timetable/getOrganisations');
                    })
        }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.selectedOrganisations = [];

        this.availableOrganisations = this.item.availableOrganisations;
        for (var o of this.item.addedOrganisations) {
            if (o && !this.listContains(o, this.selectedOrganisations)) {
                this.selectedOrganisations.push({ id: o.id, label: o.id + " - " + o.name })
            }
        }
        this.ok = this.error = this.loading = false;

    }
}
</script>

